import { render, staticRenderFns } from "./CharityProfile.vue?vue&type=template&id=30675f02&scoped=true"
import script from "./CharityProfile.vue?vue&type=script&lang=js"
export * from "./CharityProfile.vue?vue&type=script&lang=js"
import style0 from "./CharityProfile.vue?vue&type=style&index=0&id=30675f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30675f02",
  null
  
)

export default component.exports